export default "__VITE_ASSET__CkoF0jSL__"